import Hero from "@/components/Hero";
import VenturesCarousel from "@/components/VenturesCarousel";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import ProjectsGrid from "@/components/ProjectsGrid";
import About from "@/components/About";
import ContactForm from "@/components/ContactForm";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <VenturesCarousel />
      <Marquee />
      <ProjectsGrid />
      <Manifesto />
      <About />
      <ContactForm />
    </main>
  );
}
